<template>
    <div>
        <v-container fluid>
            <v-row class="p-3">
                <v-col
                        v-for="(image,index) in img"
                        :key="image.id"
                        cols="12"
                        :class="isMobile?'mx-auto my-2 card boxStyle' : 'mx-3 my-2 card boxStyle' "
                        md="2"
                        :data-img="image.id"
                >
                    <v-radio-group class="p-0 m-0" v-model="selectedImage">
                        <v-radio
                                color="indigo"
                                :value="image.value"
                        ></v-radio>
                    </v-radio-group>
                    <img :src="image.full_path"  class="img-fluid"
                         :key="image.id">
                    <p class="text-center my-0">{{image.name}}</p>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
    name: "cardType",
    data() {
        return {
            selectedImage: [],
            img: [
                {
                    id: '1',
                    name: 'کارت ویزیت سلفون براق',
                    value: 'shinyCellphane',
                    full_path: require('../../../../public/media/site/card/2/کارت-ویزیت-سلفون-براق.png')
                },
                {
                    id: '2',
                    name: 'کارت ویزیت لمینت براق',
                    value: 'shinyLaminate',
                    full_path: require('../../../../public/media/site/card/2/کارت-ویزیت-لمینت-براق.png')
                },
                {
                    id: '3',
                    name: 'کارت ویزیت لمینت مات',
                    value: 'matteLaminate',
                    full_path: require('../../../../public/media/site/card/2/کارت-ویزیت-لمینت-مات.png')
                },
                {
                    id: '4',
                    name: 'کارت ویزیت گلاسه یو وی',
                    value: 'uvGlasse',
                    full_path: require('../../../../public/media/site/card/2/کارت-ویزیت-گلاسه-ویوی.png')
                },
                {
                    id: '5',
                    name: 'کارت ویزیت کتان آلمان',
                    value: 'germanCotton',
                    full_path: require('../../../../public/media/site/card/2/کارت-ویزیت-کتان-المان.png')
                },
                {
                    id: '6',
                    name: 'کارت ویزیت کتان پلاستیک',
                    value: 'plasticCotton',
                    full_path: require('../../../../public/media/site/card/2/کارت-ویزیت-کتان-پلاستیک.png')
                },
                {
                    id: '7',
                    name: 'کارت ویزیت لمینت برجسته طلاکوب',
                    value: 'highlightGold',
                    full_path: require('../../../../public/media/site/card/2/کارت-ویزیت-لمینت-برجسته-طلا-کوب.png')
                },
                {
                    id: '8',
                    name: 'کارت ویزیت لمینت مخملی برجسته',
                    value: 'velvetyHighlight',
                    full_path: require('../../../../public/media/site/card/2/کارت-ویزیت-لمینت-مخملی-برجسته.png')
                },
                {
                    id: '9',
                    name: 'کارت ویزیت شیشه ایی',
                    value: 'glassy',
                    full_path: require('../../../../public/media/site/card/2/کارت-ویزیت-شیشه-ایی.png')
                },
                {
                    id: '10',
                    name: 'کارت ویزیت سلفون مات برجسته',
                    value: 'highlightMatteCellphane',
                    full_path: require('../../../../public/media/site/card/2/کارت-ویزیت-سلفون-مات-برجسته.png')
                },
                {
                    id: '11',
                    name: 'کارت ویزیت سلفون مخملی',
                    value: 'highlightvelvetyCellphane',
                    full_path: require('../../../../public/media/site/card/2/کارت-ویزیت-سلفون-مخملی.png')
                },
                {
                    id: '12',
                    name: 'کارت ویزیت سلفون مخملی برجسته',
                    value: 'velvetyCellphane',
                    full_path: require('../../../../public/media/site/card/2/کارت-ویزیت-سلفون-مخملی-برجسته.png')
                },
                {
                    id: '13',
                    name: 'کارت ویزیت سلفون مخملی طلاکوب',
                    value: 'goldvelvetyCellphane',
                    full_path: require('../../../../public/media/site/card/2/کارت-ویزیت-سلفون-مخملی-طلا-کوب.png')
                },
                {
                    id: '14',
                    name: 'کارت ویزیت پی وی سی',
                    value: 'pvc',
                    full_path: require('../../../../public/media/site/card/2/کارت-ویزیت-پی-وی-سی.png')
                },
                {
                    id: '15',
                    name: 'کارت ویزیت پی وی سی760 میکرون متالیک',
                    value: 'pvc760Micron',
                    full_path: require('../../../../public/media/site/card/2/کارت-ویزیت-پی-وی-سی-760-میکرون-متالیک.png')
                },
                {
                    id: '16',
                    name: 'کارت ویزیت پی‌وی‌سی 760 متالیک',
                    value: 'pvc760metalic',
                    full_path: require('../../../../public/media/site/card/2/کارت-ویزیت-پی-وی-سی-760-متالیک.png')
                },
                {
                    id: '17',
                    name: 'کارت ویزیت آهنربایی',
                    value: 'magnet',
                    full_path: require('../../../../public/media/site/card/2/کارت-ویزیت-آهن-زابایی.png')
                },
            ],
            count: 1,
        }
    },
    watch:{
        selectedImage() {
            this.$emit('persianName',this.img.find((x)=>x.value === this.selectedImage).name,"visitType")
            this.$emit('input', this.selectedImage)
        }
    }
}
</script>

<style scoped>

</style>